import React from 'react';
import { Box, Typography } from '@mui/material';
import { useDragLayer } from 'react-dnd';

/*
  DragPreviewLayer: Trello-style custom drag preview.
  Renders a compact, slightly rotated, shadowed card that follows the
  cursor while dragging. Pair with `preview(getEmptyImage())` in the
  draggable component so the browser's default snapshot is suppressed.

  Expects drag items shaped like { name, color?, width? }.
*/

export default function DragPreviewLayer() {
  const { isDragging, item, currentOffset } = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  }));

  if (!isDragging || !currentOffset || !item?.name) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        pointerEvents: 'none',
        zIndex: (theme) => theme.zIndex.modal + 1,
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
      }}
    >
      <Box
        sx={{
          transform: `translate(${currentOffset.x}px, ${currentOffset.y}px) rotate(3deg)`,
          transformOrigin: 'top left',
          width: item.width ? Math.min(item.width, 420) : 320,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          px: 1.5,
          py: 1,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: '0 12px 28px rgba(0, 0, 0, 0.22)',
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        {item.color && (
          <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: item.color, flexShrink: 0 }} />
        )}
        <Typography variant="subtitle2" fontWeight={600} noWrap>
          {item.name}
        </Typography>
      </Box>
    </Box>
  );
}
